import React from "react";
import { Box, Paper, Typography, LinearProgress } from "@mui/material";
import { groupDataByTitle } from "./workReportUtils";
import WorkHistoryGroup from "./WorkHistoryGroup";

interface WorkHistoryListProps {
  workHistory: any;
  isLoading: boolean;
  showOnlyLatestLogs: boolean;
  userId: string;
  userName: string;
}

const WorkHistoryList: React.FC<WorkHistoryListProps> = ({
  workHistory,
  isLoading,
  showOnlyLatestLogs,
  userId,
  userName,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ width: "100%", mt: 2 }}>
        <LinearProgress />
        <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
          در حال بارگیری گزارش...
        </Typography>
      </Box>
    );
  }

  const data = workHistory?.data || workHistory || [];
  console.log("🚀 ~ WorkHistoryList ~ data:", data);
  const hasData = data.length > 0;

  if (!hasData) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          هیچ رکوردی برای فیلترهای انتخاب شده یافت نشد
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          لطفاً فیلترهای دیگری امتحان کنید
        </Typography>
      </Box>
    );
  }

  const groupedData = groupDataByTitle(
    data,
    showOnlyLatestLogs,
    userId,
    userName
  );
  console.log("🚀 ~ WorkHistoryList ~ groupedData:", groupedData);

  return (
    <Paper elevation={1} sx={{ mt: 2 }}>
      <Box sx={{ p: 2 }}>
        {showOnlyLatestLogs && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: "#e3f2fd",
              borderRadius: 1,
            }}
          >
            <Typography
              variant="body2"
              color="primary"
              sx={{ fontWeight: "bold" }}
            >
              ⚠️ نمایش فقط آخرین لاگ وضعیتی هر کار فعال است
            </Typography>
          </Box>
        )}

        {groupedData.map((group, index) => (
          <WorkHistoryGroup
            key={index}
            title={group.title}
            items={group.items}
            count={group.count}
            defaultExpanded={index === 0}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default WorkHistoryList;
